import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { paymentMethods } from '../../data/landing';
const assurances = [{
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function FinalCta() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-93" data-mp="1eqe87de3bf6z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-94" data-mp="1iqy30ab6y6py">
        <p className="flex items-center justify-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-danger md:text-base" data-id="element-95" data-mp="14q3u7qk8e3qr">
          <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="19of6s91wusco" />
          El precio cierra en:
        </p>
        <div className="mt-6" data-id="element-97" data-mp="2z56ffc28yznv">
          <Countdown data-id="element-98" data-mp="2z4xztceqpg8z" />
        </div>

        <div className="mt-12" data-id="element-99" data-mp="342zivxc61fkg">
          <PriceCard subtitle="5 Tomos + 5 Bonos + Plan Maestro · Todos los días (7 → 30 días)" ctaLabel="Quiero mi MegaPack" data-id="element-100" data-mp="3426j5gbmjqbt" />
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-semibold text-charcoal" data-id="element-101" data-mp="3tfxy1587a6ul">
          {assurances.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2" data-id="element-102" data-mp="b39h21y1ckwm">
              <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-103" data-mp="70d7f0qh3z4t" />
              {label}
            </li>)}
        </ul>
        <p className="mt-4 flex items-center justify-center gap-2 text-sm text-muted" data-id="element-104" data-mp="3fhhnf377vw76">
          <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-105" data-mp="3ain0bp27vlh9" />
          {paymentMethods}
        </p>
      </div>
    </section>;
}